import React from "react";
import LoginMobileView from "./LoginMobileView";
import LoginWindowsView from "./LoginWindowsView";
import LoginMacView from "./LoginMacView";
import { isMacOs, isWindows, isMobileOnly } from "react-device-detect";
import useLoginState from "../../hooks/useLoginState";


const GoogleChrome = () => {
  const loginState = useLoginState();

  return (
    <>
      {isMobileOnly && <LoginMobileView {...loginState} />}
      {isMacOs && <LoginMacView {...loginState} />}
      {isWindows && <LoginWindowsView {...loginState} />}
    </>
  );
};

export default GoogleChrome;
